import React from 'react';
import { InboxIcon } from 'lucide-react';
interface StatePanelProps {
  variant: 'loading' | 'error' | 'empty';
  title?: string;
  message: string;
  onRetry?: () => void;
}
export function StatePanel({
  variant,
  title,
  message,
  onRetry
}: StatePanelProps) {
  return <div role={variant === 'error' ? 'alert' : variant === 'loading' ? 'status' : undefined} className={`flex flex-col items-center justify-center rounded-xl border px-6 py-16 text-center shadow-card ${variant === 'error' ? 'border-red-200 bg-red-50' : 'border-slate-200 bg-white'}`} data-id="element-505" data-mp="12ewku9ntl3l8">
      {variant === 'loading' ? <span aria-hidden="true" className="h-8 w-8 animate-spin rounded-full border-[3px] border-slate-200 border-t-brand-600" data-id="element-506" data-mp="eoiucnkvvcsr" /> : null}
      {variant === 'empty' ? <span aria-hidden="true" className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400" data-id="element-507" data-mp="3j30pxa7acr7y">
          <InboxIcon className="h-6 w-6" data-id="element-508" data-mp="2sp1fll57e29s" />
        </span> : null}
      {title ? <h2 className={`mt-4 text-base font-bold ${variant === 'error' ? 'text-red-800' : 'text-slate-900'}`} data-id="element-509" data-mp="2npoy7fx3pnel">{title}</h2> : null}
      <p className={`mt-2 max-w-md text-sm ${variant === 'error' ? 'text-red-700' : 'text-slate-500'}`} data-id="element-510" data-mp="2ixf9u4bmwvef">{message}</p>
      {onRetry ? <button type="button" onClick={onRetry} className="mt-5 rounded-lg bg-brand-700 px-4 py-2 text-sm font-semibold text-white transition hover:bg-brand-800" data-id="element-511" data-mp="2dxsw7trw9d53">
          Try again
        </button> : null}
    </div>;
}